// extracted by mini-css-extract-plugin
export default {"header_height":"86px","footer_height":"720px"};